<template>
  <div class="alert" role="alert">
    <icon :icon="['fad', this.icon]"/>
    {{text}}
  </div>
</template>

<script>
  export default {
    props: {
      text: String,
      icon: String,
    },
    name: "Infopanel"
  }
</script>

<style scoped>

</style>
